import { Route } from "@angular/router";
import { UnAuthGuard, AuthGuard } from "@mobi-office-ui";
import { DashboardComponent } from "./startup/dashboard/dashboard.component";
import { LoginComponent } from "./startup/login/login.component";
import { TeamComponent } from "./startup/team/team.component";

export const appRoutes: Route[] = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [UnAuthGuard],
  },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "team",
    component: TeamComponent,
    canActivate: [AuthGuard],
  },
];
